import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import styles from "./Css/GarhwaliCarousel.module.css";
import { useNavigate } from "react-router-dom";
import { useRecentlyAddedContent } from "../../hooks/useHomePageHooks";

const RecentlyAddedCarousel = () => {
  const { recentlyAddedContent, isLoading, error } = useRecentlyAddedContent();

  const navigate = useNavigate();

  if (isLoading || error || !recentlyAddedContent?.length) return null;

  // Limit to 10 items if there are more
  const contentItems = recentlyAddedContent.slice(0, 10);

  return (
    <div className={styles.carouselContainer}>
      <h2 className={styles.title}>Recently Added</h2>
      <Swiper
        modules={[Mousewheel, FreeMode]}
        grabCursor={window.innerWidth < 768}
        freeMode={{
          enabled: true,
          momentum: true,
          momentumRatio: 0.8,
          momentumVelocityRatio: 0.8,
          minimumVelocity: 0.02,
        }}
        mousewheel={
          window.innerWidth >= 768
            ? {
                forceToAxis: true,
                sensitivity: 1.5,
                releaseOnEdges: true,
              }
            : false
        }
        speed={600}
        resistance={false}
        resistanceRatio={0}
        slidesPerView={3}
        spaceBetween={15}
        breakpoints={{
          768: { slidesPerView: 5, spaceBetween: 10 },
          320: { slidesPerView: 3, spaceBetween: 8 },
          1200: { slidesPerView: 7, spaceBetween: 12 },
        }}
        className={styles.swiper}
      >
        {contentItems.map((item) => (
          <SwiperSlide key={item.id} className={styles.slide}>
            <div className={styles.card}>
              <img
                src={item.mobile_image_url}
                alt={item.title}
                className={styles.image}
                onClick={() => {
                  if (item.item_type === "audio") {
                    navigate(`/audio-play/${item.slug}`);
                  } else if (
                    item.item_type === "ebook" &&
                    item.series_id === null
                  ) {
                    navigate(`/book-detail/${item.slug}`);
                  } else {
                    navigate(`/book-details/${item.slug}`);
                  }
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default RecentlyAddedCarousel;
